import { createBrowserHistory } from 'history';
import { clearUnwantedHistoryState } from './services/utils/router-state-util';

const history = clearUnwantedHistoryState(createBrowserHistory());
export default history;
